import logoSvg from '@/assets/favicon.svg'
import { cn } from '@/lib/utils'

interface LogoProps {
  className?: string
  size?: 'sm' | 'md' | 'lg'
  showText?: boolean
  textClassName?: string
}

const sizeClasses = {
  sm: 'w-6 h-6',
  md: 'w-8 h-8',
  lg: 'w-12 h-12'
}

export function Logo({ 
  className, 
  size = 'md', 
  showText = true, 
  textClassName 
}: LogoProps) {
  return (
    <div className="flex items-center space-x-2">
      <img 
        src={logoSvg} 
        alt="PlusE Finance" 
        className={cn(sizeClasses[size], className)} 
      />
      {showText && (
        <span className={cn("text-xl font-bold", textClassName)}>
          PlusE Finance
        </span>
      )}
    </div>
  )
}